<template>
    <el-form ref="form" :model="industryModel" :rules="rules" label-width="150px">

        <el-form-item label="學年" prop="schoolYear">
            <el-input v-model="industryModel.schoolYear" placeholder="請輸入學年"></el-input>
        </el-form-item>
        <el-form-item label="學期" prop="semester">
            <el-select v-model="industryModel.semester" placeholder="請選擇學年">
                <el-option v-for="smt in semesters" :key="smt.value" :label="smt.text" :value="smt.value"></el-option>
            </el-select>
        </el-form-item>
        <el-divider content-position="left">甲班</el-divider>
        <el-form-item label="學期開始日期" prop="dateBeginA">
            <el-date-picker
                    v-model="industryModel.dateBeginA"
                    type="date"
                    value-format="yyyy-MM-dd"
                    :picker-options="{firstDayOfWeek:1}"
            ></el-date-picker>
        </el-form-item>
        <el-form-item label="學期結束日期" prop="dateEndA">
            <el-date-picker
                    v-model="industryModel.dateEndA"
                    type="date"
                    value-format="yyyy-MM-dd"
                    :picker-options="{firstDayOfWeek:1}"
            ></el-date-picker>
        </el-form-item>
        <el-divider content-position="left">乙班</el-divider>
        <el-form-item label="學期開始日期" prop="dateBeginB">
            <el-date-picker
                    v-model="industryModel.dateBeginB"
                    type="date"
                    value-format="yyyy-MM-dd"
                    :picker-options="{firstDayOfWeek:1}"
            ></el-date-picker>
        </el-form-item>
        <el-form-item label="學期結束日期" prop="dateEndB">
            <el-date-picker
                    v-model="industryModel.dateEndB"
                    type="date"
                    value-format="yyyy-MM-dd"
                    :picker-options="{firstDayOfWeek:1}"
            ></el-date-picker>
        </el-form-item>
        <el-button @click="submit">
            變更
        </el-button>
    </el-form>
</template>

<script>
    import {createNamespacedHelpers} from 'vuex';
    import {Semesters} from '../../constants';

    const {mapState, mapActions} = createNamespacedHelpers('setting');
    export default {
        name: 'IndustryForm',
        data: () => ({
            industryModel: {
                schoolYear: '',
                semester: 0,
                dateBeginA:'',
                dateEndA:'',
                dateBeginB:'',
                dateEndB:'',
            },
            rules: {
                schoolYear: [
                    {required: true, message: '請輸入學年!', trigger: 'blur'}
                ],
                semester: [
                    {required: true, message: '請選擇學期!'}
                ],
                dateBeginA: [
                    {required: true, message: '請輸入借用開始日期!', trigger: 'blur'}
                ],
                dateEndA: [
                    {required: true, message: '請輸入借用結束日期!', trigger: 'blur'}
                ],
                dateBeginB: [
                    {required: true, message: '請輸入借用開始日期!', trigger: 'blur'}
                ],
                dateEndB: [
                    {required: true, message: '請輸入借用結束日期!', trigger: 'blur'}
                ]
            }
        }),
        computed: {
            semesters() {
                return Semesters;
            },
            ...mapState(['industry']),
        },
        methods: {
            ...mapActions({
                saveIndustry: 'saveIndustryAction',
                getIndustry: 'getIndustryAction',
            }),
            async submit() {
                const {form} = this.$refs;
                form.validate(async (valid) => {
                    if (valid) {
                        const {success} = await this.saveIndustry(this.industryModel);
                        if(success){
                            this.$message({
                               type: 'success',
                               message: '異動成功'
                            });
                            form.clearValidate();
                        }

                    } else {
                        this.$message({
                            type: 'warning',
                            message: '您有欄位未填寫'
                        });
                    }
                });
            }
        },
        watch: {
            industry: {
                handler: function (industry) {
                    const {
                        schoolYear,
                        semester,
                        dateBeginA,
                        dateEndA,
                        dateBeginB,
                        dateEndB
                    } = industry;
                    this.industryModel.semester = semester;
                    this.industryModel.schoolYear = schoolYear;
                    this.industryModel.dateBeginA = dateBeginA;
                    this.industryModel.dateEndA = dateEndA;
                    this.industryModel.dateBeginB = dateBeginB;
                    this.industryModel.dateEndB = dateEndB;
                },
                deep: true,

            }
        },
        async created() {
            await this.getIndustry();
        }
    }
</script>

<style scoped>

</style>